import * as React from 'react';
import { Bem, addClass } from '../../utils';
import './Drawer.css';
import { useId } from '../../utils/hooks/useId';
import { useAnimationStage } from '../../utils/hooks/useAnimationStage';
const bem = Bem.create('vai-drawer');
export const Drawer = React.forwardRef(function Drawer(props, ref) {
    const { dataTa = 'vai-drawer', htmlId, width, height, children, anchor = 'Right', animated = true, isOpen, underNavigation = false, style = {}, onClick, className, overlay = false, onOverlayClick, ...rest } = props;
    const id = useId(htmlId, ['drawer']);
    const stackingPosition = underNavigation ? 'under' : 'above';
    const classNames = addClass(className, bem.block(anchor.toLowerCase(), isOpen ? '' : 'closed', animated ? 'animated' : '', `stacked-${stackingPosition}-navigation`));
    const defaultWidth = anchor === 'Left' || anchor === 'Right' ? '200px' : '';
    const defaultHeight = anchor === 'Top' || anchor === 'Bottom' ? '200px' : '';
    const backgroundRef = React.useRef(null);
    const stage = useAnimationStage(isOpen);
    const displayBackground = overlay && isOpen && stage !== 'hidden';
    React.useEffect(() => {
        if (overlay && onOverlayClick && backgroundRef.current !== null) {
            const backgroundEl = backgroundRef.current;
            const onClick = () => onOverlayClick();
            backgroundEl.addEventListener('click', onClick);
            return () => {
                backgroundEl.removeEventListener('click', onClick);
            };
        }
        return undefined;
    }, [overlay, onOverlayClick, displayBackground]);
    const styles = {
        width: width || defaultWidth,
        height: height || defaultHeight,
        ...style,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", Object.assign({ id: id.toString(), "data-ta": dataTa, "data-ta-status": isOpen ? 'visible' : 'hidden', className: classNames, style: styles, onClick: onClick, ref: ref }, rest), children),
        displayBackground && (React.createElement("div", { className: addClass(bem.element('background')(stage)), ref: backgroundRef, "data-ta": "vai-modal-background" }))));
});
//# sourceMappingURL=Drawer.js.map